enum IntegratedPartnerTypeEnum {
  LEGAL_INSURANCE = 'legalInsurance',
  LANDLORD = 'landlord',
  BROKER = 'broker',
}

export type IntegratedPartnerType = {
  id: string;
  slug: string;
  partnerType:
    | IntegratedPartnerTypeEnum.LANDLORD
    | IntegratedPartnerTypeEnum.LEGAL_INSURANCE
    | IntegratedPartnerTypeEnum.BROKER;
  options?: string[];
};

export { IntegratedPartnerTypeEnum };
